import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { useCookies } from 'react-cookie';
import { Menu, X } from 'lucide-react';

export default function Navbarr() {
  const [cookies] = useCookies(['token']);
  const token = cookies.token;
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (token) {
      window.location.href = "/home";
    }
  }, [token]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#whyChoose', label: 'Why Choose Us' },
    { href: '#whatMakes', label: 'Features' },
    { href: '#coreFeatures', label: 'How It Works' },
    { href: '#contactUs', label: 'Get Started' }
  ];

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${
      scrolled 
        ? 'bg-white/95 backdrop-blur-md shadow-lg border-b border-gray-100' 
        : 'bg-white shadow-sm'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="w-10 h-10 dynamic-site-bg rounded-xl flex items-center justify-center">
              <span className="text-white font-bold text-lg">C</span>
            </div>
            <span className="text-2xl font-bold dynamic-site-bg bg-clip-text text-transparent">
              Communiticate
            </span>
          </Link>
          
          {/* Desktop Navigation */}
          <div className="hidden lg:flex lg:items-center lg:space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-gray-700 hover:text-purple-600 px-3 py-2 text-sm font-medium transition-all duration-200 hover:scale-105 relative group"
                onClick={() => setExpanded(false)}
              >
                {link.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 dynamic-site-bg transition-all duration-300 group-hover:w-full"></span>
              </a>
            ))}
          </div>
          
          {/* Join Community Button */}
          <Link to="/login" className="hidden lg:block">
            <button className="dynamic-site-bg hover:from-blue-600 hover:to-purple-600 text-white px-6 py-2.5 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 hover:shadow-lg">
              Join Community
            </button>
          </Link>
          
          {/* Mobile menu button */}
          <button
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? (
              <X className="h-6 w-6 text-gray-600" />
            ) : (
              <Menu className="h-6 w-6 text-gray-600" />
            )}
          </button>
        </div>
        
        {/* Mobile menu */}
        {expanded && (
          <div className="lg:hidden absolute top-full left-0 right-0 bg-white/95 backdrop-blur-md border-t border-gray-100 shadow-lg">
            <div className="px-4 py-6 space-y-4">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="block text-gray-700 hover:text-purple-600 py-3 px-4 rounded-lg hover:bg-gray-50 font-medium transition-colors"
                  onClick={() => setExpanded(false)}
                >
                  {link.label}
                </a>
              ))}
              <Link to="/login" className="block mt-4">
                <button className="w-full dynamic-site-bg text-white py-3 px-4 rounded-lg font-semibold transition-all duration-300">
                  Join Community
                </button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
